export default class GlobalFormPopup {

    /**
     * GlobalFormPopup constructor
     * @param $triggerElement {Element|null}
     * @param $popupElement {Element|null}
     * @param $backgroundElement {Element|null}
     */
    constructor($triggerElement = null, $popupElement = null, $backgroundElement = null) {
        if ($triggerElement === null || !$triggerElement instanceof Element) throw new Error('Missing required parameter `$triggerElement` in class GlobalFormPopup or given parameter was not a valid Element.')
        if ($popupElement === null || !$popupElement instanceof Element) throw new Error('Missing required parameter `$popupElement` in class GlobalFormPopup or given parameter was not a valid Element.')
        if ($backgroundElement === null || !$backgroundElement instanceof Element) throw new Error('Missing required parameter `$backgroundElement` in class GlobalFormPopup or given parameter was not a valid Element.')

        /**
         * Define LS key names
         * @type {string}
         */
        this.LS_POPUP_CLOSED = 'global_popup_closed'
        this.LS_TRIGGER_CLOSED = 'global_popup_trigger_closed'

        /**
         * Define delays
         * @type {number}
         */
        this.DELAY_POPUP = 3000
        this.DELAY_TRIGGER = 1000

        /**
         * Define hash name for activating global form popup
         * @type {string}
         */
        this.ACTIVATION_HASH = 'global-form-popup'

        //init dataLayer
        window.dataLayer = window.dataLayer || []

        //lines below are used for debugging purposes
        // if (window.location.href.includes('.test')) {
        //     localStorage.setItem(this.LS_POPUP_CLOSED, "0")
        //     localStorage.setItem(this.LS_TRIGGER_CLOSED, "0")
        // }

        this.state = {
            $triggerElement,
            $triggerLink: $triggerElement.querySelector('.gfp-trigger__button'),
            $triggerClose: $triggerElement.querySelector('.gfp-trigger__close'),
            $popupElement,
            $popupClose: $popupElement.querySelector('.gfp-popup__close'),
            $popupContent: $popupElement.querySelector('.gfp-popup__content'),
            $backgroundElement,
            isDesktop: (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) >= 992,
            popupClosed: localStorage.getItem(this.LS_POPUP_CLOSED) === '1',
            triggerClosed: localStorage.getItem(this.LS_TRIGGER_CLOSED) === '1',
            formId: parseInt($popupElement.getAttribute('data-gfp-form-id')),
            formSubmitted: false
        }

        //handle hashtag on load
        if (window.location.hash === `#${this.ACTIVATION_HASH}`) {
            this.showPopup()
        } else {
            //handle not closed trigger yet
            if (!this.state.triggerClosed) setTimeout(() => this.showTrigger(), this.DELAY_TRIGGER)
        }

        //handle trigger click (close trigger and open popup
        this.state.$triggerLink.addEventListener('click', this.handleTriggerClick.bind(this))

        //handle close button for trigger
        this.state.$triggerClose.addEventListener('click', this.handleTriggerClose.bind(this))

        //handle close button for popup
        this.state.$popupClose.addEventListener('click', this.handlePopupClose.bind(this))

        //handle popup button click
        this.state.$backgroundElement.addEventListener('click', this.handlePopupClose.bind(this))

        //close popup on ESC press on desktop
        if (this.state.isDesktop) window.addEventListener("keyup", this.handleKeyPress.bind(this))

        //handle hash change
        const $hashLinks = Array.from(document.querySelectorAll(`[href="#${this.ACTIVATION_HASH}"]`))
        $hashLinks.forEach($hashLink => {
            $hashLink.addEventListener('click', (event) => {
                if (event) event.stopPropagation()
                this.hideTrigger()
                this.showPopup()
                window.dataLayer.push({event: 'global_form_hash_open'})
            })
        })

        //handle gravity form submitted
        jQuery(document).on('gform_confirmation_loaded', this.handleGformSubmit.bind(this))
    }

    /**
     * Handle Gravity Form submit
     * @param event
     * @param formId
     */
    handleGformSubmit(event, formId) {
        if (formId === this.state.formId) {
            this.state.formSubmitted = true
            this.disablePopupLs()
            this.disableTriggerLs()
            window.dataLayer.push({event: 'global_form_popup_submit'})
            if (window.location.hash === `#${this.ACTIVATION_HASH}`) history.pushState({}, '', '#')

            //hide popup content after submit
            if (this.state.$popupContent) this.state.$popupContent.style.display = 'none'
        }
    }

    /**
     * Close on ESC
     */
    handleKeyPress(event) {
        if (event.keyCode === 27) this.handlePopupClose()
    }

    /**
     * Handle trigger link click
     * @param event
     */
    handleTriggerClick(event) {
        if (event) event.preventDefault()
        this.hideTrigger()
        this.showPopup()
        window.dataLayer.push({event: 'global_form_trigger_click'})
    }

    /**
     * Handle trigger close click
     * @param event
     */
    handleTriggerClose(event) {
        if (event) event.preventDefault()
        this.hideTrigger()
        this.disableTriggerLs()
        window.dataLayer.push({event: 'global_form_trigger_close'})
    }

    /**
     * Handle popup close click
     * @param event
     */
    handlePopupClose(event) {
        if (event) event.preventDefault()
        this.hidePopup()

        if (!this.state.formSubmitted) {
            this.showTrigger()
        } else {
            this.disableTriggerLs()
        }

        this.disablePopupLs()
        window.dataLayer.push({event: 'global_form_popup_close'})
    }

    /**
     * Show popup
     */
    showPopup() {
        this.state.$popupElement.setAttribute("data-gfp-popup-active", "true")
        this.state.$backgroundElement.setAttribute("data-gfp-popup-active", "true")
        window.dataLayer.push({event: 'global_form_popup_show'})
    }

    /**
     * Hide popup
     */
    hidePopup() {
        this.state.$popupElement.setAttribute("data-gfp-popup-active", "false")
        this.state.$backgroundElement.setAttribute("data-gfp-popup-active", "false")
        window.dataLayer.push({event: 'global_form_popup_hide'})
        if (window.location.hash === `#${this.ACTIVATION_HASH}`) history.pushState({}, '', '#')
    }

    /**
     * Show trigger
     */
    showTrigger() {
        this.state.$triggerElement.setAttribute("data-gfp-trigger-active", "true")
        window.dataLayer.push({event: 'global_form_trigger_show'})
    }

    /**
     * Hide trigger
     */
    hideTrigger() {
        this.state.$triggerElement.setAttribute("data-gfp-trigger-active", "false")
        window.dataLayer.push({event: 'global_form_trigger_hide'})
    }

    /**
     * Disable trigger LS
     */
    disableTriggerLs() {
        localStorage.setItem(this.LS_TRIGGER_CLOSED, "1")
    }

    /**
     * Disable popup LS
     */
    disablePopupLs() {
        localStorage.setItem(this.LS_POPUP_CLOSED, "1")
    }
}